import React, { useEffect, useRef, useState } from "react";
import "../../style/gameMaster/ListingPage.scss";
import hint from "../../images/hint-inactive.svg";
import hintActive from "../../images/hint-active-red.svg";
import team from "../../images/team.jpg";
import undoIcon from "../../images/undo-icon.svg";

import { useTransition, animated } from "react-spring";
import Button from "../../elements/Button";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { API } from "../../services/base";
import axios from "../../services/https";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GoBack from "../GoBack";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getResetRoom } from "../../redux/actions/app.js";
import moment from "moment";
import { TailSpin } from "react-loader-spinner";

import { domen } from "../../services/base";
import {
  formatTimer,
  getTeamTimer,
  parseElapsedTime,
} from "../../utils/roomTimer";

const MyPlatform = () => {
  const [complete, setComplete] = useState(false);
  const [giveHint, setGiveHint] = useState(false);
  const [resetRoom, setResetRoom] = useState(false);
  const [undoStep, setUndoStep] = useState(false);
  let [hintCount, setHintCount] = useState(
    parseInt(localStorage.getItem("hintCount")) || 0
  );
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [room, setRoom] = useState(localStorage.getItem("room"));

  const [stepUndo, setStepUndo] = useState("");

  let [newHints, setNewHints] = useState(0);

  let [currentTime, setCurrentTime] = useState("");

  const [listingDetails, setListingDetails] = useState("");
  const [steps, setSteps] = useState([]);

  const [expanded, setExpanded] = useState("panel1");

  const dispatch = useDispatch();
  const app = useSelector((state) => state.app);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  //   Complete
  const transitionsComplete = useTransition(complete, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    delay: 300,
  });

  const completeTransitions = useTransition(complete, {
    from: { opacity: 0, transform: "translateX(100%)" },
    enter: { opacity: 1, transform: "translateX(100%)" },
    leave: { opacity: 0, transform: "translateX(100%)" },
    delay: 300,
  });
  //   End complete

  //   Give hint
  const transitionsHint = useTransition(giveHint, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    delay: 300,
  });

  const hintTransitions = useTransition(giveHint, {
    from: { opacity: 0, transform: "translateX(100%)" },
    enter: { opacity: 1, transform: "translateX(100%)" },
    leave: { opacity: 0, transform: "translateX(100%)" },
    delay: 300,
  });
  //   End give hint

  // Undo step
  const transitionsUndo = useTransition(undoStep, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    delay: 300,
  });

  const undoTransitions = useTransition(undoStep, {
    from: { opacity: 0, transform: "translateX(100%)" },
    enter: { opacity: 1, transform: "translateX(100%)" },
    leave: { opacity: 0, transform: "translateX(100%)" },
    delay: 300,
  });
  // End undo step

  //   Reset room
  const transitionsReset = useTransition(resetRoom, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    delay: 300,
  });

  const resetTransitions = useTransition(resetRoom, {
    from: { opacity: 0, transform: "translateX(100%)" },
    enter: { opacity: 1, transform: "translateX(100%)" },
    leave: { opacity: 0, transform: "translateX(100%)" },
    delay: 300,
  });
  //   End reset room

  const [teamGameId, setTeamGameId] = useState("");
  const [gmData, setGmData] = useState("");
  const [timerTeam, setTimerTeam] = useState(null);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const [loader, setLoader] = useState(false);
  const finishInFlightRef = useRef(false);
  const finishGameIdRef = useRef(null);
  const lastFinishAttemptRef = useRef(0);
  const navigate = useNavigate();

  const fetchGmData = () => {
    setLoader(true);
    axios
      .get(`${API}/room`)
      .then((res) => {
        const roomData = res.data.data;
        const gameInProgress = roomData.gameInProgress;

        setListingDetails(roomData);
        setSteps(roomData.steps);

        if (!gameInProgress || typeof gameInProgress !== "object") {
          setGmData([]);
          setTimerTeam(null);
          return;
        }

        setTeamGameId(gameInProgress.id);
        localStorage.setItem("gameCheckId", gameInProgress.id);

        const fetchedGmData = gameInProgress.teams;
        setGmData(fetchedGmData);
        const activeTeam = fetchedGmData.find(
          (item) => String(item.roomId) === String(roomData.id)
        );

        if (activeTeam) {
          const fallbackStartedAt = new Date(
            Date.now() - parseElapsedTime(activeTeam.elapsedTime) * 1000
          ).toISOString();

          setTimerTeam((previousTeam) => ({
            ...activeTeam,
            gameStartedAt:
              activeTeam.gameStartedAt ||
              (previousTeam?.id === activeTeam.id
                ? previousTeam.gameStartedAt
                : fallbackStartedAt),
            roomDuration: activeTeam.roomDuration || roomData.duration,
          }));
        } else {
          setTimerTeam(null);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (!timerTeam || !teamGameId) {
      return undefined;
    }

    if (finishGameIdRef.current !== teamGameId) {
      finishGameIdRef.current = teamGameId;
      finishInFlightRef.current = false;
      lastFinishAttemptRef.current = 0;
    }

    const updateTimer = () => {
      const now = Date.now();
      const timer = getTeamTimer(timerTeam, now);

      setElapsedSeconds(timer.displayElapsedSeconds);

      const canRetry = now - lastFinishAttemptRef.current >= 5000;

      if (
        timer.expired &&
        !timerTeam.gameFinishedAt &&
        !finishInFlightRef.current &&
        canRetry
      ) {
        finishInFlightRef.current = true;
        lastFinishAttemptRef.current = now;

        axios
          .post(`${API}/game/${teamGameId}/finish`, { game: teamGameId })
          .then(() => {
            navigate("/congratulations");
          })
          .catch((err) => {
            console.log(err);
            finishInFlightRef.current = false;
          });
      }
    };

    updateTimer();
    const intervalId = setInterval(updateTimer, 1000);

    return () => clearInterval(intervalId);
  }, [navigate, teamGameId, timerTeam]);

  useEffect(() => {
    fetchGmData();
  }, []);

  const handleCompleteRoom = () => {
    const data = {
      game: teamGameId,
    };
    axios
      .post(`${API}/game/${teamGameId}/finish`, data)
      .then((res) => {
        const completeTeam = res.data.data.teams.find((obj) => {
          return obj.id === app.team.id;
        });
        navigate("/congratulations");
        setHintCount(0);
        localStorage.removeItem("hintCount");
        const updatedSteps = steps.map((step) => ({
          ...step,
          checked: false,
        }));
        setSteps(updatedSteps);

        // Update the checked values in local storage
        const storedCheckedSteps = {};
        localStorage.setItem(
          "checkedSteps",
          JSON.stringify(storedCheckedSteps)
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleGiveHint = () => {
    const data = {
      game: teamGameId,
    };
    axios
      .post(`${API}/game/${teamGameId}/hint`, data)
      .then((res) => {
        setGiveHint(!giveHint);
        // setHintCount(hintCount + 1);
        fetchGmData();
        // localStorage.setItem("hintCount", hintCount + 1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const handleResetRoom = () => {
  //   const data = {
  //     game: app.lobby.id,
  //   };

  //   if (app.get.length > 1) {
  //     axios
  //       .post(`${API}/game/${app.lobby.id}/finish`, data)
  //       .then((res) => {
  //         navigate(`/check/${token}`);
  //         setTimeout(() => {
  //           axios
  //             .post(`${API}/room/reset`)
  //             .then((res) => {
  //               navigate(`/check/${token}`);
  //             })
  //             .catch((err) => {
  //               console.log(err);
  //             });
  //         }, 2000);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   } else {
  //     axios
  //       .post(`${API}/room/reset`)
  //       .then((res) => {
  //         navigate(`/check/${token}`);
  //         localStorage.removeItem("persist:root");
  //         window.location.reload(false);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // };

  const handleResetRoom = () => {
    const data = {
      game: teamGameId,
    };

    axios
      .post(`${API}/game/${teamGameId}/finish`, data)
      .then((res) => {
        navigate(`/check/${token}`);
        setTimeout(() => {
          axios
            .post(`${API}/room/reset`)
            .then((res) => {
              navigate(`/check/${token}`);
              localStorage.removeItem("persist:root");
              localStorage.removeItem("roomChannel");
              localStorage.removeItem("gameId");
              localStorage.removeItem("socketChannel");

              window.location.reload(false);

              setHintCount(0);
              localStorage.removeItem("hintCount");
              const updatedSteps = steps.map((step) => ({
                ...step,
                checked: false,
              }));
              setSteps(updatedSteps);

              // Update the checked values in local storage
              const storedCheckedSteps = {};
              localStorage.setItem(
                "checkedSteps",
                JSON.stringify(storedCheckedSteps)
              );
            })
            .catch((err) => {
              console.log(err);
            });
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [loadingUndo, setLoadingUndo] = useState(false);

  const handleCheckBox = (event, index, id) => {
    const checked = event.target.checked;

    const element = document.getElementById(id);
    element.style.display = "block";

    const data = {
      game: teamGameId,
      step: id,
      checked,
    };

    axios
      .post(`${API}/game/${teamGameId}/step/${id}`, data)
      .then((res) => {
        // Handle the response data as needed
        console.log(res.data.data.completedSteps, "post");

        // Update the steps in the state
        const updatedSteps = steps.map((step) =>
          step.id === id ? { ...step, checked } : step
        );
        setSteps(updatedSteps);

        // Update the checked values in local storage
        const storedCheckedSteps =
          JSON.parse(localStorage.getItem("checkedSteps")) || {};
        storedCheckedSteps[id] = checked;
        localStorage.setItem(
          "checkedSteps",
          JSON.stringify(storedCheckedSteps)
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const savedClickedSteps = localStorage.getItem("clickedSteps");
    if (savedClickedSteps) {
      const parsedClickedSteps = JSON.parse(savedClickedSteps);
      console.log("Parsed Clicked Steps:", parsedClickedSteps);
      setSteps(parsedClickedSteps);
    }
  }, []);

  const handleUndoStepPopup = () => {
    const data = {
      game: teamGameId,
      step: stepUndo,
    };

    setLoadingUndo(true);

    axios
      .delete(`${API}/game/${teamGameId}/step/${stepUndo}`, data)
      .then((res) => {
        setUndoStep(!undoStep);

        setSteps((prevSteps) =>
          prevSteps.map((step) =>
            step.id === stepUndo ? { ...step, checked: false } : step
          )
        );

        const storedCheckedSteps =
          JSON.parse(localStorage.getItem("checkedSteps")) || {};
        storedCheckedSteps[stepUndo] = false; // Set to false
        localStorage.setItem(
          "checkedSteps",
          JSON.stringify(storedCheckedSteps)
        );

        const element = document.getElementById(stepUndo);
        element.style.display = "none";

        const text = document.getElementById("step" + stepUndo);
        text.style.color = "#fff";

        document.getElementById("check" + stepUndo).checked = false;

        // var x = document.getElementById("check" + stepUndo);
        // var i;
        // for (i = 0; i <= x.length; i++) {
        //   x[i].value = false;
        // }
        setLoadingUndo(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUndo = (id) => {
    setStepUndo(id);
    setUndoStep(!undoStep);
  };

  // Convert duration from minutes to mm:ss format
  const durationInMinutes = listingDetails.duration;
  const minutes = Math.floor(durationInMinutes);
  const seconds = Math.floor((durationInMinutes - minutes) * 60);

  // Create mm:ss formatted string
  const formattedDuration = `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;

  return (
    <div className="listingPage">
      <div className="listingPageWrap">
        {/* <GoBack /> */}
        {/* Leave match */}
        {transitionsComplete(
          (styles, item) =>
            item && (
              <animated.div
                style={styles}
                className="popupBackground"
                onClick={() => setComplete(false)}
              ></animated.div>
            )
        )}

        {completeTransitions(
          (styles, item) =>
            item && (
              <animated.div style={styles} className="matchPopup">
                <div className="matchContent">
                  <h2 className="leaveMatchTitle">
                    {/* Are You Sure You Want To Complete Room? */}
                    Please confirm
                  </h2>
                  <Button
                    title="COMPLETE THE ROOM"
                    className="stayBtn"
                    onClick={handleCompleteRoom}
                  />
                  <Link
                    className="leaveMatch"
                    onClick={() => setComplete(false)}
                  >
                    go back
                  </Link>
                </div>
              </animated.div>
            )
        )}
        {/* End leave match */}

        {/* Give hint */}
        {transitionsHint(
          (styles, item) =>
            item && (
              <animated.div
                style={styles}
                className="popupBackground"
                onClick={() => setGiveHint(false)}
              ></animated.div>
            )
        )}

        {hintTransitions(
          (styles, item) =>
            item && (
              <animated.div style={styles} className="matchPopup">
                <div className="matchContent">
                  <h2 className="leaveMatchTitle">
                    {/* Are you sure you want to give hint to your team? */}
                    Give a hint?
                  </h2>
                  <Button
                    title="Yes!"
                    className="stayBtn"
                    onClick={handleGiveHint}
                  />
                  <Link
                    className="leaveMatch"
                    onClick={() => setGiveHint(false)}
                  >
                    go back
                  </Link>
                </div>
              </animated.div>
            )
        )}
        {/* End give hint */}

        {/* Undo */}
        {transitionsUndo(
          (styles, item) =>
            item && (
              <animated.div
                style={styles}
                className="popupBackground"
                onClick={() => setUndoStep(false)}
              ></animated.div>
            )
        )}

        {undoTransitions(
          (styles, item) =>
            item && (
              <animated.div style={styles} className="matchPopup">
                <div className="matchContent">
                  {!loadingUndo ? (
                    <>
                      <h2 className="leaveMatchTitle">
                        Are you sure you want to undo step?
                      </h2>
                      <Button
                        title="UNDO STEP"
                        className="stayBtn"
                        onClick={handleUndoStepPopup}
                      />
                      <Link
                        className="leaveMatch"
                        onClick={() => setUndoStep(false)}
                      >
                        go back
                      </Link>
                    </>
                  ) : (
                    <TailSpin
                      height="40"
                      width="40"
                      color="#808080"
                      ariaLabel="tail-spin-loading"
                      radius="1"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                    />
                  )}
                </div>
              </animated.div>
            )
        )}
        {/* End give undo */}

        {/* Reset room */}
        {transitionsReset(
          (styles, item) =>
            item && (
              <animated.div
                style={styles}
                className="popupBackground"
                onClick={() => setResetRoom(false)}
              ></animated.div>
            )
        )}

        {resetTransitions(
          (styles, item) =>
            item && (
              <animated.div style={styles} className="matchPopup">
                <div className="matchContent">
                  <h2 className="leaveMatchTitle">
                    Are you sure you want to reset your escape room?
                  </h2>
                  <Button
                    title="RESET ROOM"
                    className="stayBtn"
                    onClick={handleResetRoom}
                  />
                  <Link
                    className="leaveMatch"
                    onClick={() => setResetRoom(false)}
                  >
                    go back
                  </Link>
                </div>
              </animated.div>
            )
        )}
        {/* End reset room */}

        <div className="header resetRoom">
          <button className="resetBtn" onClick={() => setResetRoom(!resetRoom)}>
            RESET YOUR ESCAPE ROOM
          </button>
        </div>

        <div className="content">
          <div className="timeSpent">
            <h6>Time Spent</h6>

            <span className="timer">
              <span className="timer">
                {loader ? (
                  <TailSpin
                    height="40"
                    width="40"
                    color="#808080"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                ) : (
                  formatTimer(elapsedSeconds)
                )}
              </span>
            </span>
          </div>

          <div className="hints">
            <h6>Hints</h6>
            <div>
              {Array.isArray(gmData) ? (
                gmData.map((item, index) => {
                  if (item.roomId === listingDetails.id) {
                    return (
                      <div key={index}>
                        {" "}
                        {(() => {
                          if (item.hintCount === 1) {
                            return (
                              <div className="allHints">
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                              </div>
                            );
                          } else if (item.hintCount === 2) {
                            return (
                              <div className="allHints">
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                              </div>
                            );
                          } else if (item.hintCount === 3) {
                            return (
                              <div className="allHints">
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                              </div>
                            );
                          } else if (item.hintCount === 4) {
                            return (
                              <div className="allHints">
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                              </div>
                            );
                          } else if (item.hintCount === 5) {
                            return (
                              <div className="allHints">
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                              </div>
                            );
                          } else if (item.hintCount > 5) {
                            return (
                              <div className="allHints">
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <img src={hintActive} alt="hint-inactive" />
                                <span>+ {item.hintCount - 5}</span>
                              </div>
                            );
                          } else {
                            return (
                              <div className="allHints">
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                                <img src={hint} alt="hint-inactive" />
                              </div>
                            );
                          }
                        })()}
                      </div>
                    );
                  }
                  return null;
                })
              ) : (
                <></>
              )}
            </div>

            <Button
              title="give a hint"
              onClick={() => setGiveHint(!giveHint)}
            />
          </div>

          <div className="steps">
            <h6>Escape Room Steps</h6>

            {loader ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <TailSpin
                  height="40"
                  width="40"
                  color="#808080"
                  ariaLabel="tail-spin-loading"
                  radius="1"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              </div>
            ) : (
              <div className="allSteps">
                {steps.map((item, i) => (
                  <div className="roomStep" key={item.id}>
                    <input
                      type="checkbox"
                      checked={item.checked}
                      onChange={(e) => handleCheckBox(e, i, item.id)}
                      id={`check${item.id}`}
                      disabled={item.checked ? true : false}
                    />
                    <span
                      style={{
                        color: item.checked ? "#767676" : "#fff",
                      }}
                      id={`step${item.id}`}
                    >
                      {item.name}
                    </span>
                    <img
                      className="undoIcon"
                      style={{
                        display: item.checked ? "block" : "none",
                      }}
                      id={item.id}
                      src={undoIcon}
                      alt="undoIcon"
                      onClick={() => handleUndo(item.id, item.checked)}
                    />
                  </div>
                ))}
              </div>
            )}

            <div></div>
          </div>

          <div className="teamCards">
            {loader ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <TailSpin
                  height="40"
                  width="40"
                  color="#808080"
                  ariaLabel="tail-spin-loading"
                  radius="1"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                />
              </div>
            ) : (
              <div className="card">
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className="globalDropdown"
                  >
                    <Typography component={"span"} className="teamDropdown">
                      <span>Team Name</span>
                      {/* {app.team.name} */}
                      {Array.isArray(gmData) ? (
                        gmData.map((item, index) => {
                          if (item.roomId === listingDetails.id) {
                            return <div key={index}>{item.name}</div>;
                          }
                          return null;
                        })
                      ) : (
                        <></>
                      )}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordionDetails">
                    <Typography
                      component={"span"}
                      className="teamImageAccordion"
                    >
                      <div className="teamImage">
                        <div className="image">
                          {Array.isArray(gmData) ? (
                            gmData.map((item, index) => {
                              if (item.roomId === listingDetails.id) {
                                return (
                                  <img
                                    src={`https://prod.arenacompetition.world${item.image}`}
                                    alt="team"
                                    key={index}
                                  />
                                );
                              }
                              return null;
                            })
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                      <div className="teamInfo">
                        <div className="roomFranchize">
                          <span>Escape Room Company</span>
                          <h5>{listingDetails.company?.name}</h5>
                        </div>

                        <div className="location">
                          <span>Escape Room Location</span>
                          {!listingDetails.location ? (
                            <h5>-</h5>
                          ) : (
                            <h5>{listingDetails.location}</h5>
                          )}
                        </div>

                        <div className="roomName">
                          <span>Escape Room Name</span>
                          <h5>{listingDetails.name}</h5>
                        </div>

                        <div className="difficultyLevel">
                          <span>Difficulty Level</span>
                          <h5>{listingDetails.difficultyLevel}</h5>
                        </div>

                        <div className="solvingFrame">
                          <span>Time Frame For Solving</span>
                          <h5>{listingDetails.duration} minutes</h5>
                        </div>
                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            )}
          </div>

          <div className="resetRoom">
            <button
              className="completeRoom"
              onClick={() => setComplete(!complete)}
            >
              COMPLETE THE ROOM
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPlatform;
